export default __webpack_public_path__ + "static/media/scaffolding-30 1.b1b99441.jpg";